(function () {

seedWebApp.controller('ConfigColumnsCtrl', ConfigColumns);

    function ConfigColumns(columns, translation, $rootScope, $timeout, $uibModalInstance, StoreService, ToastService) {
        var ctrl = this;

        ctrl.translation = translation;
        ctrl.columns = columns;
        //ctrl.contactID = contactID;

        ctrl.saveConfig = function () {
            StoreService.configureColumnLayout(JSON.stringify(ctrl.columns)).then(function (response) {
                successToast('Suas Configurações Foram Salvas');
            })
            .catch(function (error) {
                errorToast('Erro ao Salvar as Configurações');
            });

            $uibModalInstance.close();
        }

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.toggleColumnView = function (col) {
            $timeout(function () {
                col.hide = !col.hide;
            });
        }

        ctrl.onDrop = function (listColumns, columnIndex, targetList, targetIndex) {
            $timeout(function () {
                targetList.splice(targetIndex, 0, listColumns[columnIndex]);

                if (listColumns == targetList) {
                    if (targetIndex <= columnIndex)
                        columnIndex++;

                    targetList.splice(columnIndex, 1);

                    if (targetIndex > columnIndex)
                        targetIndex -= 2;
                }
                ctrl.columns = targetList;

                $rootScope.$broadcast('columnsChange', ctrl.columns);
            });
            return true;
        }

        function successToast(msg) {
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }

        function errorToast(error) {
            ToastService.createToast(ctrl.translation.Error, error, 5000, 'error');
        }
    }
})()